import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from "react";
import { useIntl } from "react-intl";

var OfflinePlaceholder = function OfflinePlaceholder() {
  var intl = useIntl();
  return React.createElement(React.Fragment, null, intl.formatMessage(_defineProperty({
    defaultMessage: " OFFLINE :(",
    "id": "components.OfflinePlaceholder.3937248898"
  }, "id", "components.OfflinePlaceholder.3937248898")));
};

export default OfflinePlaceholder;